import { render, staticRenderFns } from "./EditVatStateModal.vue?vue&type=template&id=1fed52f2&"
import script from "./EditVatStateModal.vue?vue&type=script&lang=ts&"
export * from "./EditVatStateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports